import { Button, Grid, IconButton, Typography } from '@material-ui/core'
import useStyles from '../../../../../styles'
import {
  KeyboardArrowUp,
  KeyboardArrowDown,
  ArrowForward,
} from '@material-ui/icons'
import { jobCompleted, newJob } from 'assets/index'
import { PropertyActivityActiveData } from 'ducks/types'

const PaymentStep = ({
  activeData,
  show,
  setShow,
}: {
  activeData?: PropertyActivityActiveData
  show?: boolean
  setShow?: (value: boolean) => {}
}) => {
  const styles = useStyles()

  return (
    <Grid item container spacing={2} direction="column">
      <Grid
        item
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <img
            src={jobCompleted}
            style={{ width: '52px', height: '52px' }}
            alt="estimate"
          />
        </Grid>
        <Grid item style={{ flexGrow: 1 }}>
          <Typography
            className={styles.nextArtTitle}
            style={{ fontWeight: 700 }}
          >
            PAYMENT
          </Typography>
          <Typography className={styles.title}>
            {`Amount in Due: ${activeData?.customerOwed !== null ? `$${activeData?.customerOwed}` : "-"}`}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PaymentStep
